import React, { useEffect, useState } from 'react';

import { Stack } from '@mui/material';

import { UserGroup } from '../../types/common';
import Chip from '../Chip';
import StaffGroupChip, { StaffGroupChipProps } from '../StaffGroupChip';

interface StaffGroupChipsArrayProps {
  groups: UserGroup[];
  limit?: number,
  chipProps?: Omit<StaffGroupChipProps, 'group'>,
}

const StaffGroupChipsArray = ({
  groups, limit = Infinity, chipProps,
}: StaffGroupChipsArrayProps) => {
  const [sortedGroups, setSortedGroups] = useState<UserGroup[]>([]);

  useEffect(() => {
    // Sort in the order of: Owner, Manager, Admin, Teacher
    if (groups) {
      setSortedGroups([...groups].sort((a, b) => {
        if (a === b) return 0;
        if (a === UserGroup.Owners) return -1;
        if (b === UserGroup.Owners) return 1;
        if (a === UserGroup.Managers) return -1;
        if (b === UserGroup.Managers) return 1;
        if (a === UserGroup.Admins) return -1;
        if (b === UserGroup.Admins) return 1;
        if (a === UserGroup.Teachers) return -1;
        if (b === UserGroup.Teachers) return 1;
        return 0;
      }));
    }
  }, [groups]);

  if (groups.length <= limit) {
    return (
      <Stack direction="row" spacing={1}>
        {sortedGroups.map((group) => (
          <StaffGroupChip
            key={group}
            group={group}
            {...chipProps}
          />
        ))}
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={1}>
      {sortedGroups.slice(0, limit).map((group) => (
        <StaffGroupChip
          key={group}
          group={group}
          {...chipProps}
        />
      ))}
      <Chip
        {...chipProps}
        color="gray"
        label={`+${sortedGroups.length - limit}`}
        variant="outlined"
      />
    </Stack>
  );
};

export default StaffGroupChipsArray;
